<template>
    <Page noMenu class="ma-auto py-5 form">
        <v-img height="36" contain position="left center" src="/static/logo_u.svg"></v-img>
        <slot></slot>
    </Page>
</template>

<script>
import Page from "@/pages/Page";
export default {
    components: {Page},
}
</script>

<style scoped>
.form {
    font-family: Poppins, sans-serif;
    width: min(600px, 100vw);
}
</style>
